import type { Item } from '@/lib/api/types/items';
import { useGetWorkIntegrationIdsByItemIds } from './useGetWorkIntegrationItems';

export const useGetItemWorkIntegration = (
  item: Pick<Item, 'id' | 'externalKey'> | undefined,
): { isOrphan: boolean; isLoading: boolean; integrationId: number | undefined } => {
  const hasExternalKey = item != null && item.externalKey != null;
  const itemIds = hasExternalKey && item ? [item.id] : [];

  const { data, isLoading, isError } = useGetWorkIntegrationIdsByItemIds(itemIds, {
    enabled: hasExternalKey,
  });

  if (!item) return { isOrphan: false, isLoading: false, integrationId: undefined };
  if (!hasExternalKey) return { isOrphan: false, isLoading: false, integrationId: undefined };
  if (isError) return { isOrphan: false, isLoading: false, integrationId: undefined };
  if (isLoading || data == null)
    return { isOrphan: false, isLoading: true, integrationId: undefined };

  return { isOrphan: !(item.id in data), isLoading: false, integrationId: data[item.id] };
};
